export var GsStorageFormat;
(function (GsStorageFormat) {
    GsStorageFormat[GsStorageFormat["PSMCT32"] = 0] = "PSMCT32";
    GsStorageFormat[GsStorageFormat["PSMCT24"] = 1] = "PSMCT24";
    GsStorageFormat[GsStorageFormat["PSMCT16"] = 2] = "PSMCT16";
    GsStorageFormat[GsStorageFormat["PSMCT16S"] = 10] = "PSMCT16S";
    GsStorageFormat[GsStorageFormat["PSMT8"] = 19] = "PSMT8";
    GsStorageFormat[GsStorageFormat["PSMT4"] = 20] = "PSMT4";
    GsStorageFormat[GsStorageFormat["PSMT8H"] = 27] = "PSMT8H";
    GsStorageFormat[GsStorageFormat["PSMT4HL"] = 36] = "PSMT4HL";
    GsStorageFormat[GsStorageFormat["PSMT4HH"] = 44] = "PSMT4HH";
    GsStorageFormat[GsStorageFormat["PSMZ32"] = 48] = "PSMZ32";
    GsStorageFormat[GsStorageFormat["PSMZ24"] = 49] = "PSMZ24";
    GsStorageFormat[GsStorageFormat["PSMZ16"] = 50] = "PSMZ16";
    GsStorageFormat[GsStorageFormat["PSMZ16S"] = 58] = "PSMZ16S";
})(GsStorageFormat || (GsStorageFormat = {}));
;
export var GsTextureFunction;
(function (GsTextureFunction) {
    GsTextureFunction[GsTextureFunction["MODULATE"] = 0] = "MODULATE";
    GsTextureFunction[GsTextureFunction["DECAL"] = 1] = "DECAL";
    GsTextureFunction[GsTextureFunction["HIGHLIGHT"] = 2] = "HIGHLIGHT";
    GsTextureFunction[GsTextureFunction["HIGHLIGHT2"] = 3] = "HIGHLIGHT2";
})(GsTextureFunction || (GsTextureFunction = {}));
;
export var GsAlphaTestMethod;
(function (GsAlphaTestMethod) {
    GsAlphaTestMethod[GsAlphaTestMethod["NEVER"] = 0] = "NEVER";
    GsAlphaTestMethod[GsAlphaTestMethod["ALWAYS"] = 1] = "ALWAYS";
    GsAlphaTestMethod[GsAlphaTestMethod["LESS"] = 2] = "LESS";
    GsAlphaTestMethod[GsAlphaTestMethod["LEQUAL"] = 3] = "LEQUAL";
    GsAlphaTestMethod[GsAlphaTestMethod["EQUAL"] = 4] = "EQUAL";
    GsAlphaTestMethod[GsAlphaTestMethod["GEQUAL"] = 5] = "GEQUAL";
    GsAlphaTestMethod[GsAlphaTestMethod["GREATER"] = 6] = "GREATER";
    GsAlphaTestMethod[GsAlphaTestMethod["NOTEQUAL"] = 7] = "NOTEQUAL";
})(GsAlphaTestMethod || (GsAlphaTestMethod = {}));
;
export var GsAlphaFailMethod;
(function (GsAlphaFailMethod) {
    GsAlphaFailMethod[GsAlphaFailMethod["KEEP"] = 0] = "KEEP";
    GsAlphaFailMethod[GsAlphaFailMethod["FB_ONLY"] = 1] = "FB_ONLY";
    GsAlphaFailMethod[GsAlphaFailMethod["ZB_ONLY"] = 2] = "ZB_ONLY";
    GsAlphaFailMethod[GsAlphaFailMethod["RGB_ONLY"] = 3] = "RGB_ONLY";
})(GsAlphaFailMethod || (GsAlphaFailMethod = {}));
;
export var GsDepthTestMethod;
(function (GsDepthTestMethod) {
    GsDepthTestMethod[GsDepthTestMethod["NEVER"] = 0] = "NEVER";
    GsDepthTestMethod[GsDepthTestMethod["ALWAYS"] = 1] = "ALWAYS";
    GsDepthTestMethod[GsDepthTestMethod["GEQUAL"] = 2] = "GEQUAL";
    GsDepthTestMethod[GsDepthTestMethod["GREATER"] = 3] = "GREATER";
})(GsDepthTestMethod || (GsDepthTestMethod = {}));
;
export var GsFilter;
(function (GsFilter) {
    GsFilter[GsFilter["NEAREST"] = 0] = "NEAREST";
    GsFilter[GsFilter["LINEAR"] = 1] = "LINEAR";
    GsFilter[GsFilter["NEAREST_MIPMAP_NEAREST"] = 2] = "NEAREST_MIPMAP_NEAREST";
    GsFilter[GsFilter["NEAREST_MIPMAP_LINEAR"] = 3] = "NEAREST_MIPMAP_LINEAR";
    GsFilter[GsFilter["LINEAR_MIPMAP_NEAREST"] = 4] = "LINEAR_MIPMAP_NEAREST";
    GsFilter[GsFilter["LINEAR_MIPMAP_LINEAR"] = 5] = "LINEAR_MIPMAP_LINEAR";
})(GsFilter || (GsFilter = {}));
;
export var GsWrapMode;
(function (GsWrapMode) {
    GsWrapMode[GsWrapMode["REPEAT"] = 0] = "REPEAT";
    GsWrapMode[GsWrapMode["CLAMP"] = 1] = "CLAMP";
    GsWrapMode[GsWrapMode["REGION_CLAMP"] = 2] = "REGION_CLAMP";
    GsWrapMode[GsWrapMode["REGION_REPEAT"] = 3] = "REGION_REPEAT";
})(GsWrapMode || (GsWrapMode = {}));
;
export var GsColorParam;
(function (GsColorParam) {
    GsColorParam[GsColorParam["RgbSource"] = 0] = "RgbSource";
    GsColorParam[GsColorParam["RgbDest"] = 1] = "RgbDest";
    GsColorParam[GsColorParam["Zero"] = 2] = "Zero";
})(GsColorParam || (GsColorParam = {}));
;
export var GsAlphaParam;
(function (GsAlphaParam) {
    GsAlphaParam[GsAlphaParam["AlphaSource"] = 0] = "AlphaSource";
    GsAlphaParam[GsAlphaParam["AlphaDest"] = 1] = "AlphaDest";
    GsAlphaParam[GsAlphaParam["Fix"] = 2] = "Fix";
})(GsAlphaParam || (GsAlphaParam = {}));
;
export var GsRegister;
(function (GsRegister) {
    GsRegister[GsRegister["PRIM"] = 0] = "PRIM";
    GsRegister[GsRegister["RGBAQ"] = 1] = "RGBAQ";
    GsRegister[GsRegister["ST"] = 2] = "ST";
    GsRegister[GsRegister["UV"] = 3] = "UV";
    GsRegister[GsRegister["XYZF2"] = 4] = "XYZF2";
    GsRegister[GsRegister["XYZ2"] = 5] = "XYZ2";
    GsRegister[GsRegister["TEX0_1"] = 6] = "TEX0_1";
    GsRegister[GsRegister["TEX0_2"] = 7] = "TEX0_2";
    GsRegister[GsRegister["CLAMP_1"] = 8] = "CLAMP_1";
    GsRegister[GsRegister["CLAMP_2"] = 9] = "CLAMP_2";
    GsRegister[GsRegister["FOG"] = 10] = "FOG";
    GsRegister[GsRegister["XYZF3"] = 12] = "XYZF3";
    GsRegister[GsRegister["XYZ3"] = 13] = "XYZ3";
    GsRegister[GsRegister["TEX1_1"] = 20] = "TEX1_1";
    GsRegister[GsRegister["TEX1_2"] = 21] = "TEX1_2";
    GsRegister[GsRegister["TEX2_1"] = 22] = "TEX2_1";
    GsRegister[GsRegister["TEX2_2"] = 23] = "TEX2_2";
    GsRegister[GsRegister["XYOFFSET_1"] = 24] = "XYOFFSET_1";
    GsRegister[GsRegister["XYOFFSET_2"] = 25] = "XYOFFSET_2";
    GsRegister[GsRegister["PRMODECONT"] = 26] = "PRMODECONT";
    GsRegister[GsRegister["PRMODE"] = 27] = "PRMODE";
    GsRegister[GsRegister["TEXCLUT"] = 28] = "TEXCLUT";
    GsRegister[GsRegister["SCANMSK"] = 34] = "SCANMSK";
    GsRegister[GsRegister["MIPTBP1_1"] = 52] = "MIPTBP1_1";
    GsRegister[GsRegister["MIPTBP1_2"] = 53] = "MIPTBP1_2";
    GsRegister[GsRegister["MIPTBP2_1"] = 54] = "MIPTBP2_1";
    GsRegister[GsRegister["MIPTBP2_2"] = 55] = "MIPTBP2_2";
    GsRegister[GsRegister["TEXA"] = 59] = "TEXA";
    GsRegister[GsRegister["FOGCOL"] = 61] = "FOGCOL";
    GsRegister[GsRegister["TEXFLUSH"] = 63] = "TEXFLUSH";
    GsRegister[GsRegister["SCISSOR_1"] = 64] = "SCISSOR_1";
    GsRegister[GsRegister["SCISSOR_2"] = 65] = "SCISSOR_2";
    GsRegister[GsRegister["ALPHA_1"] = 66] = "ALPHA_1";
    GsRegister[GsRegister["ALPHA_2"] = 67] = "ALPHA_2";
    GsRegister[GsRegister["DIMX"] = 68] = "DIMX";
    GsRegister[GsRegister["DTHE"] = 69] = "DTHE";
    GsRegister[GsRegister["COLCLAMP"] = 70] = "COLCLAMP";
    GsRegister[GsRegister["TEST_1"] = 71] = "TEST_1";
    GsRegister[GsRegister["TEST_2"] = 72] = "TEST_2";
    GsRegister[GsRegister["PABE"] = 73] = "PABE";
    GsRegister[GsRegister["FBA_1"] = 74] = "FBA_1";
    GsRegister[GsRegister["FBA_2"] = 75] = "FBA_2";
    GsRegister[GsRegister["FRAME_1"] = 76] = "FRAME_1";
    GsRegister[GsRegister["FRAME_2"] = 77] = "FRAME_2";
    GsRegister[GsRegister["ZBUF_1"] = 78] = "ZBUF_1";
    GsRegister[GsRegister["ZBUF_2"] = 79] = "ZBUF_2";
    GsRegister[GsRegister["BITBLTBUF"] = 80] = "BITBLTBUF";
    GsRegister[GsRegister["TRXPOS"] = 81] = "TRXPOS";
    GsRegister[GsRegister["TRXREG"] = 82] = "TRXREG";
    GsRegister[GsRegister["TRXDIR"] = 83] = "TRXDIR";
    GsRegister[GsRegister["HWREG"] = 84] = "HWREG";
    GsRegister[GsRegister["SIGNAL"] = 96] = "SIGNAL";
    GsRegister[GsRegister["FINISH"] = 97] = "FINISH";
    GsRegister[GsRegister["LABEL"] = 98] = "LABEL";
})(GsRegister || (GsRegister = {}));
